/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Featured_Nothreadsdesc2Inputs */

const zh_featured_nothreadsdesc2 = /** @type {(inputs: Featured_Nothreadsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精选对话将在这里展示`)
};

const en_featured_nothreadsdesc2 = /** @type {(inputs: Featured_Nothreadsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured conversations will be displayed here`)
};

const es_featured_nothreadsdesc2 = /** @type {(inputs: Featured_Nothreadsdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las conversaciones destacadas se mostrarán aquí`)
};

/**
* | output |
* | --- |
* | "Featured conversations will be displayed here" |
*
* @param {Featured_Nothreadsdesc2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const featured_nothreadsdesc2 = /** @type {((inputs?: Featured_Nothreadsdesc2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Featured_Nothreadsdesc2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_featured_nothreadsdesc2(inputs)
	if (locale === "en") return en_featured_nothreadsdesc2(inputs)
	return es_featured_nothreadsdesc2(inputs)
});
export { featured_nothreadsdesc2 as "featured_noThreadsDesc" }